<template>
  <Modal
    :id="'cmp-distribution-reports-label_report_modal'"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t('label_report') }}</template>
    <template slot="body">
      <div class="form-group">
    
        <Dropdown
          :options="labels_TV"
          class="m2"
          :placeholder="$t('label')"
          :selected="
            labels_TV.filter(
              (e) =>
              label_ids.includes(e.value)
            )
          "
          
          v-on:selectedChange="(e) => onMultipleDropdownChange('label_id', e)"
          box
          deslect
          multiple
          allnone
          :listHeight="350"
          :showValidationIcons="false"
        ></Dropdown>
         <div style="display:flex;gap:3rem">
         
        
          <TextField
          :id="'start_date'"
          class="m1"
          style="width:30%;"
          v-bind="textFieldConfig"
          type="date"
          :value="filterSelectionData.start_date"
          required
          showValidationIcons
          :placeholder="$t('start_date')"
          @valuechanged="onTextFieldValueChange"
          immediateValidation
          @validated="onValidation"
        />
        <TextField
          :id="'end_date'"
          class="m1"
          v-bind="textFieldConfig"
          type="date"
          style="width:30%;"
          :value="filterSelectionData.end_date"
          showValidationIcons
          required
          immediateValidation
          @validated="onValidation"
          :placeholder="$t('end_date')"
          @valuechanged="onTextFieldValueChange"
        />
       
    
          <div style="padding-top:8px;width: 100%;" class="checkbox-container">
            <div class="select-checkbox">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="'account'"
                  :id="'account'"
                  @change="checkboxChange"
                  :checked="filterSelectionData.account"
                />
                <div class="checkmark"></div>
              </div>
            </div>
            <div class="select-text">{{ $t('show_accounts') }}</div>
          </div>
       
        </div>
        
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave('sales')"
      >
        {{ $dft.snakeCaseToWords("Sales Period") }}
      </button>
      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave('invoice')"
      >
        {{ $dft.snakeCaseToWords("Invoice Period") }}
      </button>

      <button
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave('payment')"
      >
        {{ $dft.snakeCaseToWords("Payment Period") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { ReportService } from "../../services/reports.service";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
import FileDownload from "js-file-download";
import { isEmpty } from "ramda";
export default {
  components: {
    InputField,
    Modal,
  },
  props: ["filteredData"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },

      validationResult: {},
      filterSelectionData: {
        label_id: null,
        report_type: null,
        start_date: null,
        end_date: null,
        account: null,
      },
      label_ids:[],
      labelReportModel: {},
    };
  },
  mounted: function () {
    this.getLabelReportModalData();
  },
  computed: {
    labels_TV: function () {
      return createTV(
        this.labelReportModel.labels || [],
        "label_name",
        "label_id"
      );
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },

  methods: {
    checkboxChange() {
      this.filterSelectionData.account = !this.filterSelectionData.account;
    },
    getLabelReportModalData: async function () {
      const result = await ReportService.getLabelReportModalData();
      this.labelReportModel = {
        ...this.labelReportModel,
        ...result.data,
      };
    },

    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onTextFieldValueChange: function (name, value) {
      if(name=='end_date' && !this.endAfterStart(this.filterSelectionData.start_date,value)){
        this.filterSelectionData[name]='';
       return;
      }
      this.filterSelectionData[name] = value;
      
    },
    endAfterStart(start, end) {
    var startDate = new Date(start);
    var endDate   = new Date(end);

    return endDate.getTime() >= startDate.getTime();
} ,
    onMultipleDropdownChange(name, value) {
      if (!isEmpty(value)) {
        this.filterSelectionData[name] = value?.map((e) => e.value).join(',') || '';
        this.label_ids=value?.map((e) => e.value);
      } 
      else {
        this.filterSelectionData[name] = '';
        this.label_ids=[];
      }
    },
    onSave: async function (report_type) {
      const res = await ReportService.getLabelReportExportData({
        ...this.filterSelectionData,
        report_type: report_type,
      });
      console.log({ fileURL: res.data });
      FileDownload(res.data, "label_report.xlsx");
      this.onCancel();
    },
    onDropdownChange: function (name, value) {
      this.filterSelectionData[name] = value.value;
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" >
.cmp-distribution-reports-label_report_modal {
  .dt-modal--body {
    margin-left: 0px;
    padding-right: 40px;
  }

  .dt-modal--options {
    justify-content: flex-start !important;
    button {
      &:first-child {
        margin-right: 42px;
      }
      &:last-child {
        margin-left: 0px;
      }
      &:nth-last-child(3) {
        margin-right: 10px;
      }
    }
  }
  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .select-checkbox {
      padding-right: 5px;
    }
  }
}
</style>
